import { render, staticRenderFns } from "./EmployerDealsDebts.vue?vue&type=template&id=23424c9f&"
import script from "./EmployerDealsDebts.vue?vue&type=script&lang=js&"
export * from "./EmployerDealsDebts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports